import { IRecurrentFrequencyOptions } from 'modules/appointments/components/frequency-select/frequency-select.component';

// interface for BusySlot
export interface IBusySlot {
	id?: string;
	professionalId?: string;
	startDate: Date;
	endDate: Date;
	description?: string;
	recurrencyType?: IRecurrentFrequencyOptions;
	recurrencyId?: string;
	isoStartDate?: string;
	isoEndDate?: string;
}

// Interface for availability slots.
export interface IAvailability {
	id?: number;
	startDate?: string;
	endDate?: string;
	weekdaySlots: IWeekdaySlot[];
	key?: string;
	timezone?: string;
}

// Interface for weekday slots.
export interface IWeekdaySlot {
	dayOfWeek: number;
	items: IWeekdaySlotItem[];
	key?: string;
}

// Interface for weekday slots items.
export interface IWeekdaySlotItem {
	startHours: number;
	startMinutes: number;
	endHours: number;
	endMinutes: number;
	startString?: string;
	endString?: string;
	key?: string;
}

// API format
export interface IAvailabilityPeriod {
	id?: number;
	availabilityId?: number;
	startTime: string;
	endTime: string;
	dayOfWeek: number;
	createdAt?: Date;
}
// API format
export interface IAvailabilityApiResponse {
	id: number;
	periods: IAvailabilityPeriod[];
	professionalId: string;
	startDate: string;
	endDate: string;
	timezone: string;
	createdAt: string;
}

export interface IAvailabilityApi {
	id: number;
	professionalId: string;
	startDate: string;
	endDate: string;
	periods: IAvailabilityPeriod[];
	timezone: string;
}

export interface INewAvailabilityApi {
	startDate: string;
	endDate: string;
	periods: IAvailabilityPeriod[];
	timezone: string;
}

export interface IUpdateAvailabilityApi {
	id: number;
	startDate: string;
	endDate: string;
	periods: IAvailabilityPeriod[];
	timezone: string;
}

export interface AvailabilityEmitter {
	isEdit: boolean;
	item: IAvailability;
	addNew: boolean;
	from?: Date;
	to?: Date;
}

export enum RecurrencyRemoveRange {
	ONLY = 'only',
	FUTURE = 'future',
	ALL = 'all',
}
